import React from 'react';

export const Check = () => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M13.8196 4.72048C14.1135 5.01444 14.1135 5.4859 13.8196 5.77987L7.06384 12.5356C6.76987 12.8296 6.29841 12.8296 6.00445 12.5356L2.26052 8.78056C1.96655 8.48659 1.96655 8.01514 2.26052 7.72117C2.55448 7.4272 3.02594 7.4272 3.31991 7.72117L6.53692 10.9382L12.7602 4.72048C13.0541 4.42651 13.5256 4.42651 13.8196 4.72048Z" fill="#1D1C28"/>
    </svg>
);
